export default function getLeadIdFromParams(): string {
    const params = new URLSearchParams(window.location.search);
    const id = params.get("id")
    if (!id) return ""
    return id
}
